<template>
    <div class="p-3">
        <div class="d-flex align-items-center">
            <vue-date-picker class="info-date-picker" v-model="startDate" placeholder="请选择起始日期"
                             :append-to-body="false" :clearable="false" :disabled-date="date => date > endDate"/>
            <div class="mx-1">0点至</div>
            <vue-date-picker class="info-date-picker" v-model="endDate" placeholder="请选择结束日期"
                             :append-to-body="false" :clearable="false"
                             :disabled-date="date => date < startDate || date > new Date()"/>
            <div class="mx-1">24点</div>
            <button class="mx-3 btn btn-primary" @click="search()">查询</button>
        </div>
        <div v-if="loading" class="my-3 text-center w-100">
            <b-spinner label="Spinner"/>
        </div>
        <table v-else class="my-3 table table-bordered">
            <thead>
            <tr>
                <th>ID</th>
                <th>码头</th>
                <th>泊位</th>
                <th>河流</th>
                <th>里程</th>
                <th>货品</th>
                <th>装卸货</th>
                <th>上下档船次</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="item in items">
                <tr :key="item.id">
                    <td>{{item.id}}</td>
                    <td>{{item.name || "——"}}</td>
                    <td>{{item.berth || "——"}}</td>
                    <td>{{item.river || "——"}}</td>
                    <td>{{Number.isFinite(item.cursor) ? item.cursor : "——"}}</td>
                    <td>{{item.cargo || "——"}}</td>
                    <td>{{item.load ? "装" : ""}}{{item.unload ? "卸" : ""}}货</td>
                    <td>
                        <div v-if="item.actions.length > 0"
                             @click="expandItemId = (expandItemId === item.id) ? 0 : item.id"
                             class="accordion-button" :class="{collapsed: expandItemId !== item.id}">
                            <div>{{item.actions.length}}</div>
                        </div>
                        <div v-else>——</div>
                    </td>
                </tr>
                <tr v-if="expandItemId === item.id" :key="'actions' + item.id">
                    <td colspan="8" class="p-2 pl-5">
                        <table class="table table-sm table-bordered">
                            <thead>
                            <tr>
                                <th>MMSI</th>
                                <th>船名</th>
                                <th>上档时间</th>
                                <th>上档航速</th>
                                <th>下档时间</th>
                                <th>下档航速</th>
                                <th>停留小时</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="action in item.actions" :key="action.id">
                                <td>{{action.mmsi}}</td>
                                <td>{{action.name || "——"}}</td>
                                <td>{{action.dockTime || "——"}}</td>
                                <td>{{action.dockSpeed || "——"}}</td>
                                <td>{{action.departTime || "——"}}</td>
                                <td>{{action.departSpeed || "——"}}</td>
                                <td>{{action.stayHours}}</td>
                                <td><a class="anchor" target="_blank" :href="action.detailUrl">详情</a></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import * as moment from "moment";
import Dock from "@/services/dock";

export default {
    name: "DockList",
    data() {
        return {
            startDate: new Date(moment().startOf("day").subtract(6, "days").valueOf()),
            endDate: new Date(moment().startOf("day").valueOf()),
            items: [],
            expandItemId: null,
            loading: false,
        };
    },
    methods: {
        async search() {
            try {
                this.loading = true;
                let items = await Dock.search(this.startDate, this.endDate);
                for (let item of items) {
                    let minLon = 180, maxLon = -180, minLat = 90, maxLat = -90;
                    for (let point of item.points) {
                        minLon = Math.min(minLon, point[0]);
                        maxLon = Math.max(maxLon, point[0]);
                        minLat = Math.min(minLat, point[1]);
                        maxLat = Math.max(maxLat, point[1]);
                    }
                    for (let action of item.actions) {
                        action.dockTime = moment(action.firstTime).format("YYYY-MM-DD HH:mm:ss");
                        action.departTime = action.isLast ? null
                            : moment(action.lastTime).format("YYYY-MM-DD HH:mm:ss");
                        action.stayHours = +(moment(action.lastTime).diff(moment(action.firstTime), "hour", true).toFixed(1));
                        let trailFrom = moment(action.firstTime).subtract(3, "days").format("YYYY-MM-DD");
                        let trailTo = moment(action.lastTime).add(3, "days").format("YYYY-MM-DD");
                        action.detailUrl = `/vue/search-map?mmsi=${action.mmsi}&vesselName=${action.name}`
                            + `&trail=1&trailFrom=${trailFrom}&trailTo=${trailTo}&trailWash=1`
                            + `&mapType=satellite&roadType=road&plot_types=${encodeURIComponent("码头")}`
                            + `&viewRect=${encodeURIComponent(`${minLon},${minLat},${maxLon},${maxLat}`)}`;
                    }
                }
                this.items = items;
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        this.search();
    }
}
</script>

<style scoped>
.accordion-button {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 1rem;
    color: #212529;
    cursor: pointer;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
}

.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
    transform: rotate(-180deg);
}

.accordion-button::after {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-left: auto;
    content: "";
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform 0.2s ease-in-out;
}
</style>
